import { render, staticRenderFns } from "./AdminDeposit.vue?vue&type=template&id=b6e2ad1e"
import script from "./AdminDeposit.vue?vue&type=script&lang=js"
export * from "./AdminDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports